import { BaseStorage } from '@app/core/service/base-storage';

export class SessionStorageService extends BaseStorage {
  protected createStorage(): void {
    this.storage = window.sessionStorage;
  }
}
